import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestCentrosCustos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'centroscustos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteCentroCusto({ payload }) {
  try {
    const { idcentrocusto, params } = payload;

    yield call(api.delete, `centroscustos/${idcentrocusto}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { centrocusto, params } = payload;

    yield call(api.post, 'centroscustos', centrocusto);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/centroscustos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idcentrocusto } = payload;

    const { data } = yield call(api.get, `centroscustos/${idcentrocusto}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { centrocusto, params } = payload;

    yield call(api.put, 'centroscustos', centrocusto);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/centroscustos');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'centroscustos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@centrocusto/CENTROSCUSTOS_IN_REQUEST', requestCentrosCustos),
  takeLatest('@centrocusto/DELETE_CENTROCUSTO', deleteCentroCusto),
  takeLatest('@centrocusto/SUCCESS_REMOVE', requestCentrosCustos),
  takeLatest('@centrocusto/STORE_CENTROCUSTO', store),
  takeLatest('@centrocusto/FIND_CENTROCUSTO', find),
  takeLatest('@centrocusto/UPDATE_CENTROCUSTO', update),
  takeLatest('@centrocusto/RECORD_FILTERING', applyedFilters),
]);
